import React, { Fragment, useEffect, useState } from "react";
import { SolidButton } from "../../global/SolidButton";
import { Copy, Plus, Trash2 } from "lucide-react";

import { PencilSimpleLine } from "phosphor-react";
import { MyModal } from "../../global/MyModal";
import MyLoader from "../../util/MyLoader";
import {
  addPayoutConfig,
  deletePayoutConfig,
  getPayoutConfigs,
  updatePayoutConfig,
} from "../apps_manage/api";

import toast from "react-hot-toast";
import { format } from "date-fns";
import Pagination from "../../util/Pagination";
import { copyToClipboard } from "../../util/UtilFunctions";

export default function PayoutConfigs() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [search, setSearch] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [payoutConfigs, setPayoutConfigs] = useState(null);
  // const [isDisabled, setDisabled] = useState(false);
  const [currentConfigId, setCurrentConfigId] = useState(null);

  const [loading, setLoading] = useState(true);

  const [nameInput, setNameInput] = useState("");
  const [valueInput, setValueInput] = useState("");

  //pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  const fetchConfigs = async () => {
    try {
      const res = await getPayoutConfigs();
      if (res?.status === 200) {
        setPayoutConfigs(res?.data?.configs || []);
        setTotal(res?.data?.total || 0);
        // setDisabled(false);
      }
    } catch (error) {
      console.error("Error fetching payout configs:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // if (didFetch.current) return;
    // didFetch.current = true;

    const timer = setTimeout(() => {
      fetchConfigs();
    }, 400);

    return () => clearTimeout(timer);
  }, [page, limit, search]);

  const handleSubmit = async () => {
    try {
      const payload = {
        name: nameInput,
        value: valueInput,
        status: false,
      };
      const res = isEditMode
        ? await updatePayoutConfig(currentConfigId, payload)
        : await addPayoutConfig(payload);
      if (res?.status === 201 || res?.status === 200) {
        toast.success(
          isEditMode
            ? "Config updated successfully!"
            : "Config added successfully!",
        );
        fetchConfigs();
        setIsModalOpen(false);
        setNameInput("");
        setValueInput("");
        setCurrentConfigId(null);
        setIsEditMode(false);
      }
    } catch (error) {
      console.error(
        isEditMode ? "Error updating config:" : "Error adding config:",
        error,
      );
    } finally {
      setIsModalOpen(false);
    }
  };

  const openEditModal = (config) => {
    setIsEditMode(true);
    setIsModalOpen(true);
    setCurrentConfigId(config.id);
    setNameInput(config.name);
    setValueInput(config.value);
  };

  const handleDelete = async () => {
    //setAppConfigs(appConfigs.filter((item) => item.id !== deleteId));
    try {
      const res = await deletePayoutConfig(deleteId);
      if (res.status === 200) {
        toast.success("Config deleted successfully");
        fetchConfigs();
      }
    } catch (err) {
      console.error("Failed to delete configuration", err);
      toast.error(err.response?.data?.error || "Failed to delete config");
    }
    setDeleteId(null);
  };

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-4 relative" id="devices-main">
        <div
          className="bg-white/80 dark:bg-slate-900/80
            backdrop-blur-xl rounded-2xl  
            border border-state-200/50 dark:border-slate-700/50 
             w-full 
             pb-4
            overflow-x-auto        
           "
        >
          <div className="flex items-center justify-between p-4 ">
            <div className="flex flex-col space-y-1 ">
              <h1 className="text-sm text-slate-900 dark:text-slate-200 font-bold">
                Configuration
              </h1>
              <span className="text-xs text-slate-500 dark:text-slate-200 font-normal">
                Manage application settings and veriables
              </span>
            </div>
            <SolidButton
              onClick={() => {
                setIsModalOpen(true);
                console.log("Add Config clicked");
              }}
              children={
                <>
                  <Plus className="w-4 h-4" />
                  <span>Add Config</span>
                </>
              }
            />
          </div>
          {/* Table */}
          <table className="min-w-full ">
            <thead>
              <tr className="bg-slate-100 dark:bg-slate-800/60 border-t border-slate-300 dark:border-slate-700">
                <th className="text-start w-[400px] text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ps-4">
                  {/* Search */}
                  <input
                    type="text"
                    placeholder="Search by name or value"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-[300px] mr-4 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                  />
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Value
                </th>
                <th className="text-end text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Date, Time
                </th>
                <th className="text-end pe-10 text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {payoutConfigs.map((item, index) => (
                <tr
                  key={index}
                  className="hover:bg-slate-100 dark:hover:bg-gray-800/20"
                >
                  <td className="text-start uppercase text-xs font-medium text-slate-900 dark:text-slate-200 py-4 ps-4">
                    {item.name}
                  </td>

                  <td className="py-4">
                    <div className="flex items-center space-x-2">
                      <code
                        className="text-xs font-normal text-slate-900 dark:text-slate-200 bg-slate-200/60 dark:bg-slate-200/10 px-2 py-1 rounded-md line-clamp-1 break-after-all 
                       max-w-80
                       overflow-scroll text-ellipsis"
                      >
                        {item.value}
                      </code>
                      <Copy
                        className="w-4 h-4 cursor-pointer text-slate-700 dark:text-slate-200"
                        onClick={() => copyToClipboard(item.value)}
                      />
                    </div>
                  </td>

                  <td className="text-end text-xs font-normal text-slate-900 dark:text-slate-200 py-4">
                    {format(item.date_time, "dd-MMM-yyyy  h:mm:ss a")}
                  </td>

                  <td className="text-end py-4">
                    <div className="flex items-center justify-end space-x-4 me-4">
                      <PencilSimpleLine
                        className="w-6 h-6 text-slate-800 dark:text-slate-200 border border-slate-200 rounded-sm p-1 cursor-pointer"
                        weight="light"
                        onClick={() => openEditModal(item)}
                      />
                      <Trash2
                        className="w-6 h-6 text-red-400 border border-slate-200 rounded-sm p-1 cursor-pointer"
                        onClick={() => setDeleteId(item.id)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="w-full b-0 absolute">
          <Pagination
            page={page}
            limit={limit}
            total={total}
            fixed={false}
            onPageChange={setPage}
            onLimitChange={(l) => {
              setLimit(l);
              setPage(1); // reset to first page
            }}
            constrainTo="#devices-main"
          />
        </div>
      </div>
      {/* ADD / EDIT MODAL */}
      <MyModal
        isOpen={isModalOpen}
        title={isEditMode ? "Edit Config" : "Add Config"}
        onClose={() => {
          setIsModalOpen(false);
          setNameInput("");
          setValueInput("");
          setCurrentConfigId(null);
          setIsEditMode(false);
        }}
      >
        <>
          {/* Name */}
          <h1 className="text-sm font-medium dark:text-slate-200 mt-4">
            Name*
          </h1>
          <input
            type="text"
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value.toUpperCase())}
            placeholder="e.g. API_KEY, MAX_UPLOAD_SIZE"
            className="w-full px-2 py-2 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md mt-2 text-slate-800 dark:text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
          />

          {/* Value */}
          <h1 className="text-sm font-medium dark:text-slate-200 mt-4">
            Value*
          </h1>
          <textarea
            value={valueInput}
            onChange={(e) => setValueInput(e.target.value)}
            placeholder="Enter config value"
            className="w-full h-32 p-3 bg-slate-100 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 rounded-lg text-sm text-slate-800 dark:text-white resize-none mt-2"
          />

          <div className="bg-slate-300 dark:bg-slate-700 h-[1px] mt-4" />

          <div className="flex items-center justify-end space-x-4 mt-4">
            <button
              className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-slate-800 dark:text-slate-300 text-sm font-semibold hover:bg-slate-400/30 transition-all"
              onClick={() => {
                setIsModalOpen(false);
                setNameInput("");
                setValueInput("");
                setCurrentConfigId(null);
                setIsEditMode(false);
              }}
            >
              Cancel
            </button>

            <SolidButton
              onClick={() => {
                handleSubmit();
              }}
              children={<span>{isEditMode ? "Update" : "Add Config"}</span>}
            />
          </div>
        </>
      </MyModal>
      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete Config?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this config?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDelete} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}
